<template lang="pug">
.label-legenda
    .titulo-legenda {{ titulo }}:
    .item-legenda(v-for='item in itens')
        .icone-legenda(:style='item.estilo')
        .texto-legenda {{ item.texto }}
</template>

<script>
export default {
    name: 'LabelLegenda',

    props: {
        titulo: {
            type: String,
            required: true
        },
        itens: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.label-legenda {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 14px;

    .titulo-legenda {
        display: inline-block;
        margin-left: 20px;
        font-weight: bold;
    }

    .item-legenda {
        display: flex;

        .icone-legenda {
            border-width: 1px;
            border-style: solid;
            margin-right: 3px;
            @include box(20px);
            @include border-radius(50px);
        }

        .texto-legenda {
            display: inline-block;
            color: #606266;
        }
    }
}
</style>
